"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgFiles = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M22.25 3.854L18.84.441A1.5 1.5 0 0017.776 0H7.19a1.5 1.5 0 00-1.5 1.5V19a1.5 1.5 0 001.5 1.5h14a1.5 1.5 0 001.5-1.5V4.914c0-.398-.157-.78-.44-1.06z" }),
        react_1.default.createElement("path", { fill: "currentColor", d: "M18.19 22h-13a1 1 0 01-1-1V3.5a1 1 0 10-2 0V21a3 3 0 003 3h13a1 1 0 100-2z" })));
};
exports.default = SvgFiles;
//# sourceMappingURL=Files.js.map